import { render, staticRenderFns } from "./PushCategorySwitch.vue?vue&type=template&id=b57505b0&"
import script from "./PushCategorySwitch.vue?vue&type=script&lang=js&"
export * from "./PushCategorySwitch.vue?vue&type=script&lang=js&"
import style0 from "./PushCategorySwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports